var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.length > 1 && !_vm.loading
    ? _c(
        "v-container",
        {
          staticClass: "app-pagination white pa-2 mb-0",
          attrs: { fluid: "", "grid-list-xl": "" },
        },
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", "align-center": "" } },
            [
              _c("v-pagination", {
                staticClass: "elavation-0",
                attrs: {
                  value: _vm.currentPagination,
                  length: _vm.length,
                  "total-visible": _vm.totalVisible,
                  color: "primary",
                  flat: "",
                },
                on: { input: _vm.onPagination },
              }),
              _vm._v(" "),
              _c("v-text-field", {
                attrs: {
                  id: "pagination-input",
                  name: "pagination-input",
                  placeholder: "Página",
                  mask: "#########",
                },
                on: { input: _vm.debouncePagination },
                model: {
                  value: _vm.goToPage,
                  callback: function ($$v) {
                    _vm.goToPage = $$v
                  },
                  expression: "goToPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }